/**
 * The one header of the product, as its three design sources draw it — Homepage, Busca de listas
 * and the host panel share this frame to the pixel: 15px above and below, the fluid gutter, 24px
 * between groups, and a porcelain-tint surface at 92% over a 14px blur with a 12% oxide rule.
 *
 * What each screen adds is its own (the public navigation, the panel's tabs and identity, the
 * sign-out of the account flows); what it sits in is this. A plain module, so server and client
 * components read the same values.
 */
export const SITE_HEADER_FRAME_CLASS =
  // 75px: the 44px control every design's header holds, its 15px above and below, and the rule —
  // stated, so a header with no such control (the account flows) stands as tall as the others.
  "box-border flex min-h-[75px] items-center justify-between gap-6 px-[clamp(20px,4vw,56px)] py-[15px]";

/** Porcelain-tint at 92%, tracking the token instead of restating the rgba. */
export const SITE_HEADER_SURFACE_CLASS =
  "border-b border-[rgb(61_63_57_/_0.12)] bg-[color-mix(in_srgb,var(--tb-porcelain-tint)_92%,transparent)] backdrop-blur-[14px]";

/**
 * The pace of the header's surface change — when the scroll crosses the hero, the background,
 * the rule, the wordmark, the navigation and the divider all turn at once.
 *
 * Only the duration and the ease: each element keeps its own `transition-*`, because the header
 * turns `background` and `border-color` while the rest turn `color`. They had drifted to three
 * durations and two eases (500ms bare, 500ms linen, 400ms bare), which is visible as the group
 * arriving in instalments.
 *
 * `--tb-duration-3` and not the 500ms the majority carried: on the wordmark and the links this
 * same transition also serves the hover, and there is no separating them — both are `color` on
 * the same element. 600ms leaves the hover mushy; 360ms sits close to what the navigation already
 * did and keeps the surface change smooth.
 */
export const SITE_HEADER_SURFACE_MOTION_CLASS =
  "duration-[var(--tb-duration-3)] ease-[var(--tb-ease-linen)]";

/**
 * The wordmark's width — one size for the whole product, the host panel's (the newest design
 * source), by the person's ruling of 2026-09-20. It rules the official logotype file
 * (`TbWordmark`, viewBox 2148.73 × 471.49), which is the file this ruler was written for.
 */
export const SITE_HEADER_LOGO_WIDTH_CLASS = "w-[clamp(142px,12.2vw,190px)]";

/** The wordmark at the head of a menu drawer, same artwork. */
export const SITE_MENU_LOGO_WIDTH_CLASS = "w-[147px]";
